import script from "./Process.vue?vue&type=script&setup=true&lang=js"
export * from "./Process.vue?vue&type=script&setup=true&lang=js"

import "./Process.vue?vue&type=style&index=0&id=3a5a6d4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5a6d4e"]])

export default __exports__